<template>
  <div>
    <template v-if="column === 'category'">
      {{ item.category && item.category.name }}
    </template>

    <template v-else-if="column === 'subcategory'">
      {{ item.subcategory && item.subcategory.name }}
    </template>

    <template v-else-if="column === 'type'">
      {{ item.type && item.type.name }}
    </template>

    <template v-else-if="column === 'guid'">
      {{ item.serialNumber }}
    </template>

    <template v-else-if="column === 'name'">
      {{ item.name }}
    </template>

    <template v-else-if="column === 'holder'">
      <a :href="`?r=redesign#/personal-employee/${item.holderId}/summary`" target="_blank">{{ item.holder }}</a>
    </template>

    <template v-else-if="column === 'expiryDate'">
      {{ item.expirationDate }}
    </template>

    <template v-else-if="column === 'issueDate'">
      {{ item.issueDate }}
    </template>

    <template v-else-if="column === 'files'">
      <div v-if="item.files.length" class="files" @click="$emit('showFiles', item)">
        {{ item.filesLabel }}
      </div>
    </template>

    <template v-else-if="column === 'cost'">
      <div v-if="item.cost" class="cost">
        {{ item.cost.toLocaleString() }}
      </div>
    </template>

    <template v-else-if="column === 'manufactureDate'">
      {{ item.productionDate }}
    </template>

    <template v-else-if="column === 'purchaseDate'">
      {{ item.purchaseDate }}
    </template>

    <template v-else-if="column === 'model'">
      {{ item.model }}
    </template>

    <template v-else-if="column === 'purchasePlace'">
      {{ item.purchasePlace }}
    </template>
  </div>
</template>

<script>
export default {
  props: ["item", "column"],
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.files {
  white-space: nowrap;
  color: $color-primary;
  cursor: pointer;
}
@include bootstrapMd {
  .cost {
    text-align: right;
  }
}
</style>
